module.exports = __webpack_public_path__ + "static/img/img-sing-up-top.0ca57b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-sing-up-top.png
// module id = 453
// module chunks = 2